import { useContext, useEffect, useState } from "react";
import React from "react";
import axios from "axios";
import { BaseUrl } from "../../BaseUrl/BaseUrl";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Mylogo from "../../assets/images/new/newLogo.jpg";
import dayjs from "dayjs";
import { handleProceedRemainingPayment } from "../RazorPay/RazorPayFunction";
import { LoaderContext } from "../../AuthContext/AuthContext";
import LazySection from "../../Pages/Home/LazySection";
import DeliveryTracker from "../DeliveryTracker/DeliveryTracker";
import { GetOrderTrackingDetails, GetProductOrderTrackingDetails } from "../../ApiServices/BookingTrack/BookingTrackApi";
import { GetProductOrderDetails, GetProductSubPackageOrderDetails } from "../../ApiServices/EStore/EStoreApi";
import HoroscopeBannerImg from "../../assets/images/new/banner-remid.jpeg";
import { CloudCog } from "lucide-react";
import { t } from "i18next";
import frontPujakit from '../../assets/images/new/PujaKitFront.png'

const OrderDetails = () => {
  const userID = JSON.parse(localStorage.getItem("userID"));
  const userKeyID = localStorage.getItem("userKeyID");
  const RazorPayKey = process.env.RazorPayKey;
  const RazorPaySecretKey = process.env.RazorPaySecretKey;
  const RazorPayName = process.env.RazorPayName;
  const [localData, setLocalData] = useState(null);
  const [totalAmount, setTotalAmount] = useState(0);
  const [pageSize, setPageSize] = useState(30);
  const [orders, setOrders] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const [OrderTrackingDetails, setOrderTrackingDetails] = useState(null)
  const { setLoader, selectedLanguageID } = useContext(LoaderContext);
  useEffect(() => {

    if (location?.state?.id === 11) {
      GetProductSubPackageOrderDetailsData()
    } else {
      GetProductOrderDetailsData()
    }
    GetOrderTrackingDetailsData()
  }, [selectedLanguageID]);

  const GetProductOrderDetailsData = async () => {

    setLoader(true);
    try {
      const response = await GetProductOrderDetails(location?.state?.order?.estoreBookingKeyID, selectedLanguageID);

      if (response?.statusCode === 200) {
        setLoader(false);
        const list = response?.responseData?.data || []
        setOrders(list)

      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };
  const GetProductSubPackageOrderDetailsData = async () => {

    setLoader(true);
    try {
      const response = await GetProductSubPackageOrderDetails(location?.state?.order?.estoreBookingKeyID, selectedLanguageID);

      if (response?.statusCode === 200) {
        setLoader(false);
        const list = response?.responseData?.data || []
        setOrders(list)

      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };


  useEffect(() => {
    const calculatedTotal = orders?.reduce(
      (total, order) =>
        total +
        order.price * order.quantity -
        Math.round((order.price * (order.discount * order.quantity)) / 100),
      0
    );
    setTotalAmount(calculatedTotal);
  }, [orders]);

  const handleProceedRemainingEStorePayment = async () => {
    if (localData?.remainingAmount === 0) {
      alert("All the amount already paid");
      return;
    }


    let orderIDReturned = location?.state?.ORDER_ID;
    const finalAmount =
      Number(location?.state?.totalPrice) +
      Number(location?.state?.SHIPING_CHARGES);


    const PlaceOrderResponse = await handleProceedRemainingPayment(Math.round(finalAmount))

    setLoader(true)
    if (PlaceOrderResponse?.status === 1) {
      axios
        .post(`${BaseUrl}/UpdatePaymentStatus?TYPE=Estore`, {
          USER_ID: userID,
          ORDER_ID: orderIDReturned,
          TRANSACTION_ID: PlaceOrderResponse?.razorpay_payment_id,
          PAYMENT_STATUS: "Success",
          TRANSACTION_STATUS: "Success",
          TRANSACTION_AMT: finalAmount,
          REMAING_AMOUNT: 0,
          PAYMENT_DATE: dayjs().format("YYYY-MM-DD"),
        })
        .then((res) => {
          if (res.data.ResponseMessage === "successfully.") {
            setLoader(false)
            navigate("/my-order");
          } else {
            setLoader(false)
            alert("Order placement failed, please try again.");
          }
        });
    } else if (PlaceOrderResponse?.status === 0) {
      setLoader(false)
      alert('Order Failed !')
    }
  };

  const handleDownloadInvoice = (ID) => {
    window.open(orders[0].invoicePDFURL, "_blank");
    // const pdfUrl = location?.state?.InvoicePDFURL; // Replace with your actual URL
    // const link = document.createElement("a");
    // link.href = pdfUrl;
    // link.download = `Invoice_${ID}.pdf`;
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
  };
  const GetOrderTrackingDetailsData = async () => {
    setLoader(true);
    try {
      let response = await GetProductOrderTrackingDetails(location?.state?.order?.estoreBookingKeyID, userKeyID, Number(selectedLanguageID)); // Replace with actual import/function call
      if (response?.statusCode === 200) {
        setLoader(false);
        const list = response?.responseData?.data || [];
        setOrderTrackingDetails(list)
      } else {
        console.error("Bad request");
        setLoader(false);
      }
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  }
  const stepMap = [
    { key: "BookingDate", label: "Booked" },
    { key: "ConfirmedDate", label: "Confirmed" },
    { key: "ProcessingDate", label: "Processed" },
    // { key: "OnTheWayDate", label: "En-Route" },
    { key: "DeliveredDate", label: "Delivered" },
    { key: "CancelledDate", label: "Cancelled" },
    { key: "RejectedDate", label: "Rejected" }
  ];

  const productsUI = () => {
    return (
      <>
        <div className="row g-4">
          {/* 🛍 Left Section – Ordered Products */}
          <div className="col-lg-8">

            {orders[0]?.productItems?.map((order, index) => (
              <div key={index} className="modern-order-card">
                <div className="order-image">
                  <img src={order?.productImageURL} alt={order?.productName} />
                </div>

                <div className="order-details">
                  <h6 className="fw-bold mb-3 " style={{ fontSize: "21px" }}>{order?.productName}</h6>
                  <p className="text-muted small mb-1">
                    {t("Seller: Myomnamo Spiritual Services Pvt. Ltd.")}
                  </p>

                  {order.discount > 0 && (
                    <p className="discount-tag">-{order.discount}% {t("OFF")}</p>
                  )}

                  <div className="price-section">
                    <h5 className=" mb-0" >
                      ₹
                      {order.price * order.quantity -
                        Math.round(
                          (order.price * (order.discount * order.quantity)) / 100
                        )}
                    </h5>
                    {order.discount > 0 && (
                      <span className="text-muted text-decoration-line-through small">
                        ₹{order.price * order.quantity}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            ))}

            {(OrderTrackingDetails !== null &&
              OrderTrackingDetails !== undefined &&
              OrderTrackingDetails !== "") && (
                <div className="tracking-card mt-4 p-4">
                  <LazySection>
                    <DeliveryTracker
                      statusData={OrderTrackingDetails}
                      stepMap={stepMap}
                      moduleName={"EStore"}
                    />
                  </LazySection>
                </div>
              )}
          </div>

          {/* 📦 Right Section – Shipping & Price Summary */}
          <div className="col-lg-4">
            <div className="summary-card">
              <h5 className="fw-bold mb-1 ">{t("Shipping Address")}</h5>
              <div className="address-box">
                <i className="fa-solid fa-location-dot me-2  mt-1 text-danger"></i>
                <p className="text-muted small mb-0">{orders[0]?.orderAddress}</p>
              </div>
            </div>

            <div className="summary-card mt-4">
              <h5 className="fw-bold mb-3 " >{t("Price Summary")}</h5>

              <div className="summary-item">
                <span>{t("Product Price")}</span>
                <span>₹{orders[0]?.totalPrice}</span>
              </div>

              {orders[0]?.couponCodeAmount !== 0 ? (
                <div className="summary-item text-danger">
                  <span>{t("Coupon Discount")}</span>
                  <span>- ₹{orders[0]?.couponCodeAmount}</span>
                </div>
              ) : orders[0]?.walletAmount !== 0 ? (
                <div className="summary-item text-danger">
                  <span>{t("Wallet Used")}</span>
                  <span>- ₹{orders[0]?.walletAmount}</span>
                </div>
              ) : (
                ""
              )}

              {/* <div className="summary-item">
                <span>{t("Tax")} ({orders[0]?.taxPercentage}%)</span>
                <span>₹{orders[0]?.taxAmount}</span>
              </div> */}

              <div className="summary-item">
                <span>{t("Delivery Charges")}</span>
                <span>₹{orders[0]?.shippingCharges}</span>
              </div>



              <div className="summary-item total">
                <span>{t("Grand Total")}</span>
                <span className=" fw-bold">
                  ₹{Number(orders[0]?.grandTotal)}
                </span>
              </div>

              {(orders[0]?.invoicePDFURL !== null && orders[0]?.invoicePDFURL !== undefined) && (
                <button
                  className="download-btn mt-4"
                  onClick={() => handleDownloadInvoice()}
                >
                  <i className="fa-solid fa-file-invoice me-2"></i> {t("Download Invoice")}
                </button>
              )}
            </div>
          </div>
        </div>
      </>
    )
  }

  const pujaKitProductsUI = () => {
    return (
      <>
        <div className="row g-4">
          {/* 🛍 Left Section – Ordered Products */}
          <div className="col-lg-8">

            {orders?.map((order, index) => (
              <div key={index} className="modern-order-card">
                <div className="order-image">
                  <img src={frontPujakit} alt={order?.productName} />
                </div>

                <div className="order-details">
                  <h6 className="fw-bold mb-3 " style={{ color: "#a42642", fontSize: "21px" }}>{order?.productName}</h6>
                  <p className="text-muted small mb-1">
                    {t("Seller: Myomnamo Spiritual Services Pvt. Ltd.")}
                  </p>

                  {order.discount > 0 && (
                    <p className="discount-tag">-{order.discount}% {t("OFF")}</p>
                  )}

                  <div className="price-section">
                    <h5 className=" mb-0" style={{ color: "#a42642" }}>
                      ₹
                      {order.price}
                    </h5>
                    {order.discount > 0 && (
                      <span className="text-muted text-decoration-line-through small">
                        ₹{order.price * order.quantity}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            ))}

            {(OrderTrackingDetails !== null &&
              OrderTrackingDetails !== undefined &&
              OrderTrackingDetails !== "") && (
                <div className="tracking-card mt-4 p-4">
                  <LazySection>
                    <DeliveryTracker
                      statusData={OrderTrackingDetails}
                      stepMap={stepMap}
                      moduleName={"EStore"}
                    />
                  </LazySection>
                </div>
              )}
          </div>

          {/* 📦 Right Section – Shipping & Price Summary */}
          <div className="col-lg-4">
            <div className="summary-card">
              <h5 className="fw-bold mb-3 " style={{ color: "#a42642" }}>Shipping Address</h5>
              <div className="address-box">
                <i className="fa-solid fa-location-dot me-2 text-danger"></i>
                <p className="text-muted small mb-0">{orders[0]?.orderAddress}</p>
              </div>
            </div>

            <div className="summary-card mt-4">
              <h5 className="fw-bold mb-3 " style={{ color: "#a42642" }}>Price Summary</h5>

              <div className="summary-item">
                <span>Product Price</span>
                <span>₹{orders[0]?.price}</span>
              </div>

              {orders[0]?.couponCodeAmount !== 0 ? (
                <div className="summary-item text-danger">
                  <span>Coupon Discount</span>
                  <span>- ₹{orders[0]?.couponCodeAmount}</span>
                </div>
              ) : orders[0]?.walletAmount !== 0 ? (
                <div className="summary-item text-danger">
                  <span>Wallet Used</span>
                  <span>- ₹{orders[0]?.walletAmount}</span>
                </div>
              ) : (
                ""
              )}



              <div className="summary-item">
                <span>Delivery Charges</span>
                <span>₹{orders[0]?.deliveryCharges}</span>
              </div>



              <div className="summary-item total">
                <span>Grand Total</span>
                <span className="text-success fw-bold">
                  ₹{Number(orders[0]?.grandTotal)}
                </span>
              </div>

              {(orders[0]?.invoicePDFURL !== null && orders[0]?.invoicePDFURL !== undefined) && (
                <button
                  className="download-btn mt-4"
                  onClick={() => handleDownloadInvoice()}
                >
                  <i className="fa-solid fa-file-invoice me-2"></i> Download Invoice
                </button>
              )}
            </div>
          </div>
        </div>
      </>
    )
  }
  return (
    <>
      <section className="page-header" style={{ paddingBottom: '28px' }}>
        <div
          className="page-header__bg horoscope-banner-responsive"
          style={{ backgroundImage: `url(${HoroscopeBannerImg})` }}
        ></div>
        <div className="container" style={{ display: 'block' }}>
          <h2 className="page-header__title bw-split-in-left">{t("Product Order Details")}</h2>

        </div>
      </section>
      <div className="order-page-container py-5">
        <div className="container">
          {location?.state?.id === 11 ? pujaKitProductsUI() : productsUI()}
        </div>
      </div>

    </>
  );
};

export default OrderDetails;
